import { SEARCH_DISPLAY_NAME } from "./core";
import createDisplayName from "../../../fabrics/createDisplayName";

export const createDisplayNameForSearchElement =
    createDisplayName(SEARCH_DISPLAY_NAME);
